import _system from '../../../libs/system';
import api from '../../../api'
//import store from '../../../store';

export const _fetchMethods = {
    methods: {
        fetch_messages(customAfter){

          if(this.getUser.email.includes("wise")){
            console.log("Juphy Special Filtering");
            return this.fetch_messages_v2({});
          }

            //this.setInboxFiltersSkip(15);
            this.setLoadingMessages(true);
  
            let payload = {
              query: {
                limit: 25,
                reverse: false,
                workspaceId: this.currentWorkspace._id
              }
            }
  
            if(this.getInboxFilters.statusId) payload.query.statusId = this.getInboxFilters.statusId
  
            if(this.getInboxFilters.pageIds) payload.query.pageId = this.getInboxFilters.pageIds
  
            if(this.getInboxFilters.tags) payload.query.tagId = this.getInboxFilters.tags
  
            if(this.getInboxFilters.notTags) payload.query.notTagId = this.getInboxFilters.notTags
  
            if(this.getInboxFilters.assignedTo) payload.query.assigneeId = this.getInboxFilters.assignedTo


            let getConversationVersion = this.$route.query.version
            if(getConversationVersion && getConversationVersion.length){
              payload.version = getConversationVersion;
              payload.query.reverse = 'true';
              payload.endpoint = 'getVersion3';
            }else{
              if(this.getInboxFilters.after) payload.query.after = this.getInboxFilters.after
              if(this.getInboxFilters.before) payload.query.before = this.getInboxFilters.before

              if(this.getUser.email.includes('wise') && this.getInboxFilters.pageIds.length){
                console.log('one pge selected');
                payload.query.after =  + new Date() - 1000*60*60*24*7;
                this.setInboxFiltersAfter(payload.query.after);
                this.startDate = new Date( payload.query.after ).toISOString()
              }
  
              if(this.getUser.email.includes('wise') && !this.getInboxFilters.pageIds.length){
                console.log('all channels selected')
                payload.query.after =  + new Date() - 1000*60*60*2*1;
                this.setInboxFiltersAfter(payload.query.after);
                this.startDate = new Date( payload.query.after ).toISOString()
              }
  
              if(this.getUser.email.includes('wise') && customAfter){
                console.log('Custom selected')
                payload.query.after =  customAfter;
                this.setInboxFiltersAfter(payload.query.after);
                this.startDate = new Date( payload.query.after ).toISOString()
              }

              payload.endpoint = 'get';
            }
  

            //payload.endpoint = 'getConversationsV2';
  
          _system.services.messages[payload.endpoint](payload, (err, data) => {
              let messages = _system.services.messages.helper(data, payload.query.reverse);
  
              messages = _.map(messages, (message) => {

                if(!message.reply){
                  message.reply = message
                }
  
                if(!message.text) message.text = ''
                if(message.reply && !message.reply.text) message.reply.text = ''
  
                if(!message.from){
                  message.from = {
                    name: 'Unknown'
                  }
                }
  
                if(!message.reply || ( message.reply && !message.reply.from)){
                  message.reply.from = {
                    name: 'Unknown'
                  }
                }
  
                if(this.networksById[message.platform].name == 'Gmail' || this.networksById[message.platform].name == 'Email'){
                  message.from.name = _.get(message, 'from.email')
                  message.to.name = _.get(message, 'to.email')
                  message.text = message.text.slice(0, 200)
                  if(message.reply){
                    message.reply.text = message.reply.text.slice(0, 200)
                    message.reply.from.name = _.get(message.reply, 'from.email')
                    message.reply.to.name = _.get(message.reply, 'to.email')
                  }
                }
  
                //Copy comment thread into inbox only for Facebook and Instagram
                if(this.threaded === 'true' && (this.networksById[message.platform].name == 'Facebook' || this.networksById[message.platform].name == 'Instagram') && !this._is(message, 'directMessage')){
                  if(message.reply && message._id != message.reply._id){
                    message.thread = {
                      exist: true,
                      loading: true
                    }
                  }
                }
  
                if(this.workspaceAccountsByPId[message.from.id]){
                  if(message.to) message.from.name = _.get(message, 'to.name')
                  if(message.to) message.from.id = _.get(message, 'to.id')
                }

                return message
              })
  

              this.setMessages(messages);

              //Update desktop app red label PUFF!
                if(window.juphyDesktopApp){
                  window.ipcRenderer.send('removePing', data);
                }
  
              this.setLoadingMessages(false);
              
              
              //Load thread comments for facebook
              for (const message of messages) {
                //If is not working
                if(this.threaded === 'true' && message.thread){
                  console.log('threaded fetched')
                  const index = _.findIndex(this.messages, { _id: message._id });
                  api.get("/api/v1/conversations/" + message._id,(err, data) => {
                    if(err) console.log(err.message);
  
  
                    if(data.replies && data.replies.length){
                            data.replies = _.map(data.replies, reply => {
                              if(!reply.from){
                                reply.from = {
                                  name: 'Unknown'
                                }
                              }
  
                              return reply;
                            })
                    }
  
                    //Mark it as a last message in the thread
                    data.replies[data.replies.length-1].last = true;
  
                    //check if reply is a connected facebook page and fix it!
                    data.replies = _.map(data.replies, (reply) => {
  
                      if(!reply.from){
                        message.reply.from = {
                          name: 'Unknown'
                        }
                      }
  
                      if (_.find(this.accountsByPId[reply.from.id])){
                        reply.from.avatar = this.accountsByPId[reply.from.id].avatar
                        return reply;
                      }else{
                        return reply;
                      }
                    });
  
                    data.replies =  _system.services.messages.helper(data.replies, payload.query.reverse);
                    data.replies =  [message].concat(data.replies);
  
                    //order By date
                    data.replies = _.orderBy(data.replies, ['createdAt'], ['asc']);
  
                    data.replies[0].first = true;
  
                    message.thread.data = data;
                    message.thread.loading = false;
                    this.$set(this.messages, index, message);
  
                  });
                }
              }
             
              
            });
        },
        fetch_messages_v2(options){
      
          //this.setInboxFiltersSkip(15);


          let payload = {
            query: {
              limit: 50,
              workspaceId: this.currentWorkspace._id
            }
          }


          if(this.getInboxFilters.pageIds.length && this.getInboxFilters.reverse){
            payload.query.limit = 400;
          }

          if(options.loadMore){
            this.loading.loadMore = true;

            if(this.getInboxFilters.pageIds.length && this.getInboxFilters.reverse){
              this.setInboxFiltersSkip(this.getInboxFilters.skip + 400)
            }else{
              this.setInboxFiltersSkip(this.getInboxFilters.skip + 50)
            }


            //this.setInboxFiltersAfter(this.messages[this.messages.length -1].createdAt);
            //this.setInboxFiltersBefore(this.messages[this.messages.length -1].createdAt);
            //this.setInboxFiltersBefore(endDate);
          }else{
            this.setInboxFiltersSkip(0)
            this.setLoadingMessages(true);
          }

          if(this.getInboxFilters.statusId) payload.query.statusId = this.getInboxFilters.statusId

          if(this.getInboxFilters.pageIds) payload.query.pageId = this.getInboxFilters.pageIds

          if(this.getInboxFilters.tags) payload.query.tagId = this.getInboxFilters.tags

          if(this.getInboxFilters.notTags) payload.query.notTagId = this.getInboxFilters.notTags

          if(this.getInboxFilters.assignedTo) payload.query.assigneeId = this.getInboxFilters.assignedTo

          if(this.getInboxFilters.reverse) payload.query.reverse = this.getInboxFilters.reverse

          if(this.getInboxFilters.skip) payload.query.skip = this.getInboxFilters.skip

          //if(this.getInboxFilters.after) payload.query.after = this.getInboxFilters.after
          //if(this.getInboxFilters.before) payload.query.before = this.getInboxFilters.before


          //let getConversationVersion = this.$route.query.version

            payload.version = "version3";
            //payload.query.reverse = 'true';
            payload.endpoint = 'getVersion3';
    

/*             if(payload.query.reverse){
              if(this.getInboxFilters.after) payload.query.after = this.getInboxFilters.after
              console.log("After : ", new Date(payload.query.after))
            }else{
              if(this.getInboxFilters.before) payload.query.before = this.getInboxFilters.before
              console.log("Before : ", new Date(payload.query.before))
            } */
            
            //payload.query.after = 1689777619000 
            //payload.query.before = 1687185619000 

            //Skip
/*             console.log(this.getInboxFilters.skip)
            if(this.getInboxFilters.skip) {
              payload.query.skip = this.getInboxFilters.skip
            } */

        _system.services.messages[payload.endpoint](payload, (err, data, headers) => {
          
          if(headers.headers && headers.headers["x-total-count"] != undefined){
            let messagesCount = headers.headers["x-total-count"]
            //store.dispatch('messages/setMessagesCount', messagesCount)
            this.setMessagesCount(messagesCount)
          }

            let messages = _system.services.messages.helper(data, payload.query.reverse);

            messages = _.map(messages, (message) => {

              if(!message.reply){
                message.reply = message
              }

              if(!message.text) message.text = ''
              if(message.reply && !message.reply.text) message.reply.text = ''

              if(!message.from){
                message.from = {
                  name: 'Unknown'
                }
              }

              if(!message.reply || ( message.reply && !message.reply.from)){
                message.reply.from = {
                  name: 'Unknown'
                }
              }

              if(this.networksById[message.platform].name == 'Gmail' || this.networksById[message.platform].name == 'Email'){
                message.from.name = _.get(message, 'from.email')
                message.to.name = _.get(message, 'to.email')
                message.text = message.text.slice(0, 200)
                if(message.reply){
                  message.reply.text = message.reply.text.slice(0, 200)
                  message.reply.from.name = _.get(message.reply, 'from.email')
                  message.reply.to.name = _.get(message.reply, 'to.email')
                }
              }

              //Copy comment thread into inbox only for Facebook and Instagram
              if(this.threaded === 'true' && (this.networksById[message.platform].name == 'Facebook' || this.networksById[message.platform].name == 'Instagram') && !this._is(message, 'directMessage')){
                if(message.reply && message._id != message.reply._id){
                  message.thread = {
                    exist: true,
                    loading: true
                  }
                }
              }

              if(this.workspaceAccountsByPId[message.from.id]){
                if(message.to) message.from.name = _.get(message, 'to.name')
                if(message.to) message.from.id = _.get(message, 'to.id')
              }

              return message
            })



            if(options.loadMore) {
              this.setConcatMessages(messages);
              this.loading.loadMore = false;
              //this.setMessages(messages);
            }else{
              this.setMessages(messages);
            }
            

            //Update desktop app red label PUFF!
              if(window.juphyDesktopApp){
                window.ipcRenderer.send('removePing', data);
              }

            this.setLoadingMessages(false);
            
            
            //Load thread comments for facebook
            for (const message of messages) {
              //If is not working
              if(this.threaded === 'true' && message.thread){
                console.log('threaded fetched')
                const index = _.findIndex(this.messages, { _id: message._id });
                api.get("/api/v1/conversations/" + message._id,(err, data) => {
                  if(err) console.log(err.message);


                  if(data.replies && data.replies.length){
                          data.replies = _.map(data.replies, reply => {
                            if(!reply.from){
                              reply.from = {
                                name: 'Unknown'
                              }
                            }

                            return reply;
                          })
                  }

                  //Mark it as a last message in the thread
                  data.replies[data.replies.length-1].last = true;

                  //check if reply is a connected facebook page and fix it!
                  data.replies = _.map(data.replies, (reply) => {

                    if(!reply.from){
                      message.reply.from = {
                        name: 'Unknown'
                      }
                    }

                    if (_.find(this.accountsByPId[reply.from.id])){
                      reply.from.avatar = this.accountsByPId[reply.from.id].avatar
                      return reply;
                    }else{
                      return reply;
                    }
                  });

                  data.replies =  _system.services.messages.helper(data.replies, payload.query.reverse);
                  data.replies =  [message].concat(data.replies);

                  //order By date
                  data.replies = _.orderBy(data.replies, ['createdAt'], ['asc']);

                  data.replies[0].first = true;

                  message.thread.data = data;
                  message.thread.loading = false;
                  this.$set(this.messages, index, message);

                });
              }
            }
            
            
          });
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/dashboard/mixins/_fetch.js